import PropTypes from 'prop-types';
import { useDispatchToStore } from '@hooks/reduxHooks';
import { fetchEnrolledCourses } from '@actions/courses';
import NewCourseCard from '@cont/EnrolledCourse/NewCourseCard';
import * as React from 'react';
import { StyledInfiniteScroll } from '@cont/EnrolledCourse/styled';

const CourseTypeBlock = ({
  courseData,
  goalUID,
  filterObj,
  isPrimaryBatch = false
}) => {
  const dispatch = useDispatchToStore();
  const loadMoreCourse = () => {
    return dispatch(fetchEnrolledCourses(goalUID, filterObj, true));
  };

  if (courseData?.results) {
    const courseInfo = { ...courseData };
    courseInfo.results = isPrimaryBatch
      ? courseInfo.results.slice(0, 3)
      : courseInfo.results;

    return (
      <StyledInfiniteScroll
        loadMore={loadMoreCourse}
        items={courseInfo.results}
        renderItem={({ item }) => <NewCourseCard course={item} />}
      />
    );
  }
  return null;
};

export default CourseTypeBlock;

CourseTypeBlock.propTypes = {
  courseData: PropTypes.objectOf(PropTypes.any).isRequired,
  goalUID: PropTypes.string.isRequired,
  filterObj: PropTypes.objectOf(PropTypes.any).isRequired,
  isPrimaryBatch: PropTypes.bool.isRequired
};
